import { gql, useMutation } from "@apollo/client";
import { MutationCreateNewProjectFileArgs } from "../../__generated__/types";

const CREATE_PROJECT_FILE_MUTATION = gql`
  mutation CreateNewProjectFile(
    $designerId: ID
    $name: String
    $description: String
    $style: ProjectStyles
    $projectCategory: ProjectCategory
    $specialRequirements: [SpecialRequirements]
    $budgetRange: BudgetRange
    $squareFootage: SquareFootage
    $projectDuration: ProjectDuration
    $images: [ID]
    $published: Boolean
  ) {
    createNewProjectFile(
      designerId: $designerId
      name: $name
      description: $description
      style: $style
      projectCategory: $projectCategory
      specialRequirements: $specialRequirements
      budgetRange: $budgetRange
      squareFootage: $squareFootage
      projectDuration: $projectDuration
      images: $images
      published: $published
    ) {
      _id
      budgetRange
      description
      designerId
      images
      name
      projectCategory
      projectDuration
      specialRequirements
      squareFootage
      style
      published
    }
  }
`;

export const useCreateProjectFileMutation = () => {
  const [createProjectFileMutation, { loading, error, data }] = useMutation(
    CREATE_PROJECT_FILE_MUTATION
  );

  const createProjectFile = async (args: MutationCreateNewProjectFileArgs) => {
    try {
      const { data } = await createProjectFileMutation({
        variables: args,
      });
      return data?.createNewProjectFile;
    } catch (error) {
      console.error("Error creating project file:", error);
      throw error;
    }
  };

  return { createProjectFile, loading, error, data };
};
